module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAOlJREFUOBGlk7ENwjAQRf+Z9FBHApkJQIICqLwKmyQjMEFWYATTIAqKbAAjhB7ZnJOgAJbBCieddPn2fzndybRYq4oIQ/QIC1TCmc9HTezPXbY1YjQ2jQbpWGacgIVigEwnkj+gYjVabhR30j9Ef2vjDALuBlNrsfv1gyCgPOkrA0oH4vkcQqAkdOB0IVAIC82AjBOWsP9cebCDFzBvqw1ymPf42oEx2BpAJ4QCBNWROkgQMF8pKQgzzqK77ldBQCJw8a/7SswMfNeL8gTk9aqadeXteZRWA/jhZDwk7bKumRCr0V/P2eL2AATnY/CSnAXRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theory/ic_video.png
// module id = 1284
// module chunks = 0